import React from 'react';
import Dialog from './Dialog';

type HelpDialogProps = {
  show: boolean
  onClose: () => void
}

export default function HelpDialog({show, onClose, children}: React.PropsWithChildren<HelpDialogProps>) {
  const handleConfirm = (e: React.MouseEvent) => {
    e.preventDefault();
    onClose();
  }

  return (
    <>
      <Dialog show={show} onClose={onClose} onConfirm={handleConfirm} actionBtnTitle="Got you!">
        {children}
      </Dialog>
    </>
  )
}
